module.exports = __webpack_public_path__ + "static/media/tech.899aafff.png";